<template>
	<v-row class='fill-height' align="end">
		<v-col cols='4' class="h-100">
			<h2 id="page-url" class="text-center text-uppercase">Visit us at argentinalot.tv</h2>
			<v-card class='w-100 white--text prizes-card align-center d-flex' rounded='xl' style="height: 95%">
				<v-row no-gutters>
					<v-col cols='12'>
						<span class='prizes-title'>Prizes</span>
						<prizes-list class='font-weight-bold' :general-information='generalInformation'>
							<template #prize-row='{prize}'>
								<v-col class='prize-name' cols='6'>
									{{ prize.name }}
								</v-col>
								<v-col class='prize-amount' cols='6'>
									{{ prize.amount }}
								</v-col>
							</template>
						</prizes-list>
					</v-col>
				</v-row>
			</v-card>
		</v-col>

		<v-col cols='4'>
			<v-row justify="center">
				<v-col cols="12">
					<v-card class='white--text rounded-xl'>
						<v-img class='mx-auto' contain width='300' :src="require('@/assets/img/argentinaLottery/logo.webp')"/>
						<hr/>
						<countdown
							id="upcoming-result"
							class="text-center"
							:sortition="generalInformation.sortition">
							<template #default='{sortition}'>
								<v-flex md3>
									<h1 class='font-weight-bold text-uppercase'>Drawing starting in</h1>
								</v-flex>
								<v-flex md3>
									<animated-clock id="clock" :general-information="generalInformation"></animated-clock>
								</v-flex>
								<v-flex md3>
									<span id='time-left' v-if='sortition.timeLeft'
												class='font-weight-black text-uppercase'>{{ sortition.timeLeft }}</span>
									<span v-else><font-awesome-icon icon='sync' spin size='3x'></font-awesome-icon></span>
								</v-flex>
							</template>
						</countdown>
						<hr/>
						<v-container>
							<v-row no-gutters justify="center">
								<v-col v-for='sortition in generalInformation.sortedSortitions' :key='sortition.id' cols='auto'>
									<span
										class="font-weight-bold mx-1 text-h6"
										:class='{"next-drawing--text": generalInformation.sortition.id === sortition.id, "white--text": generalInformation.sortition.id !== sortition.id }'>
										{{ sortition.abbreviation }}
									</span>
								</v-col>
							</v-row>
						</v-container>
						<v-img class='mx-auto' contain width='300' :src="require('@/assets/img/argentinaLottery/logo.webp')"/>
					</v-card>
				</v-col>
			</v-row>
		</v-col>

		<v-col cols='4'>
			<v-row>
				<v-col cols='12' class='text-center'>
					<div id='current-time' class='white--text'>
						<font-awesome-icon icon='clock'></font-awesome-icon>
						<current-time-display :general-information='generalInformation'>
						</current-time-display>
					</div>
				</v-col>
			</v-row>
			<v-row justify="center">
				<v-col cols="12">
					<v-card id="last-winning-card" class='white--text text-center fill-height rounded-xl'>
						<div class='font-weight-bold my-1 text-uppercase text-center text-h5 white--text'>LAST WINNNING NUMBERS</div>
						<result-horizontal-display v-if='generalInformation.results[0]'
																			 :image-dimensions="{ height: '38px', width: '38px' }"
																			 :result='generalInformation.results[0]'
																			 :pick-three-image="{ src: require('@/assets/img/argentinaLottery/pickThree.webp'), width: '90px', height: '50px',contain: true }"
																			 :pick-four-image="{ src: require('@/assets/img/argentinaLottery/pickFour.webp'), width: '90px', height: '50px', contain: true }"
						>
							<template #name="{sortition}">
								<h4 class="font-weight-bold text-uppercase text-wrap">{{ sortition.name }}</h4>
							</template>
						</result-horizontal-display>
					</v-card>
				</v-col>
			</v-row>
			<v-row no-gutters>
				<v-col cols='12' class="py-2" v-for='(result) in generalInformation.results.slice(1, 3)' :key='result.sortition.id'>
					<v-card class='white--text text-center fill-height rounded-xl'>
						<result-horizontal-display
							:result='result'
							:pick-three-image="{ src: require('@/assets/img/argentinaLottery/pickThree.webp'), width: '90px', height: '50px',contain: true }"
							:pick-four-image="{ src: require('@/assets/img/argentinaLottery/pickFour.webp'), width: '90px', height: '50px', contain: true }"
						>
							<template #name="{sortition}">
								<h4 class="font-weight-bold text-uppercase text-wrap">{{ sortition.name }}</h4>
							</template>
						</result-horizontal-display>
					</v-card>
				</v-col>
			</v-row>
		</v-col>

	</v-row>
</template>

<script>
import Countdown from '@homepage/components/Countdown.vue';
import {generateImageMapFor} from '@homepage/helpers/image.js';
import PrizesList from '@homepage/components/PrizesList.vue';
import CurrentTimeDisplay from '@homepage/components/CurrentTimeDisplay.vue';
import ResultHorizontalDisplay from "@homepage/components/ResultHorizontalDisplay.vue";
import AnimatedClock from "@homepage/components/AnimatedClock.vue";

export default {
	name: 'ArgentinaLotteryBoard',
	provide() {
		return {
			imagesMap: generateImageMapFor('quickmoney'),
			generalInformation: this.generalInformation
		};
	},
	props: {
		generalInformation: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			timeToShowResultsPage: 30000,
			timeToShowPrizesPage: 1000,
			timeToShowEachLotteryResultPage: 10000,
			lotteryEntriesPerPage: 2
		};
	},
	components: {
		AnimatedClock,
		CurrentTimeDisplay,
		ResultHorizontalDisplay,
		PrizesList,
		Countdown
	},
	// beforeCreate() {
	// 	this.$emit('change-style', {backgroundImage: require('@/assets/img/tripleplayLottery/background_2.webp')});
	// }
};
</script>
<style scoped>
* {
	color: white;
}

.theme--light.v-card {
	border: 4px solid #eac627;
	background-color: #4b94cb8c;
	-webkit-backdrop-filter: blur(5px);
	backdrop-filter: blur(5px);
}

.prizes-title {
	font-size: 300%;
	font-weight: bold;
}

.prize-name {
	font-size: 180%;
}

.prize-amount {
	font-size: 240%;
	font-weight: 800;
}

.prizes-card {
	text-align: center;
}

#current-time {
	font-size: 250%;
	font-weight: bold;
}

::v-deep .prize-item:nth-child(odd) {
	background-color: #5563a54f;
}

#time-left {
	font-weight: bold;
	font-size: 3.5rem;
	text-align: center;
	color: white;
}

@keyframes blink-border {
	from {
		border: 3px solid #4b94cb8c;
		box-shadow: 0 0 25px black;
	}
	to {
		border: 3px solid #f2bc00a1;
		box-shadow: 0 0 25px #818181;
	}
}

.next-drawing--text {
	color: #f2bc00a1;
}

#last-winning-card {
	transition: border, box-shadow;
	animation: blink-border 400ms infinite alternate ease;
}

#clock {
	max-height: 100px;
}
</style>

<style>
#inspire {
	background: url("../../../assets/img/argentinaLottery/background.webp");
}

.lottery-result:nth-child(even) {
	background-color: #eaeaea;
}
</style>
